import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';

export type GetPatientVaccinationListParams = PatientCommandParams & {
    page?: number
    perPage?: number
    reactionDateFrom?: string
    reactionDateTo?: string
    executionDateFrom?: string
    executionDateTo?: string
    writeDateFrom?: string
    writeDateTo?: string
    includeCancelled?: boolean
    onlyOwnRecords?: boolean
    onlyVaccinationWithReaction?: boolean
    atcGroup?: NCZIReference
    vaccinationKind?: NCZIReference
    vaccinationType?: NCZIReference
    vaccinationId?: NCZIExtension
    recordId?: NCZIExtension
};

export const GetPatientVaccinationList = (params: GetPatientVaccinationListParams): Command => {
    return {
        operation: 'VyhladajOckovaniaPacienta_v2',
        params
    }
}